import './core/general.js';
import './components/cookieconsent.js';
import './components/header.js';
import '@tailwindplus/elements';
import Alpine from 'alpinejs';
import sort from '@alpinejs/sort';
import persist from '@alpinejs/persist'
import 'lazysizes';
import Plyr from 'plyr';

// Components

// Global
window.Alpine = Alpine;
window.Plyr = Plyr;

// Inits
Alpine.plugin(sort);
Alpine.plugin(persist);
Alpine.start();


